import styled, { css } from "styled-components";

import Props from "./props";

const StyledLogo = styled.div<Props>`
    width: 6rem;
    height: 4rem;
    display: inline-block;
    margin: 0 0.5rem;
    position: relative;
    &:before {
        content: "";
        position: absolute;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(${(props: any) => props.theme.staticPath + "static/img/minor-logos/" + props.logo});
        background-position: center;
        ${props =>
            props.padding
                ? css`
                      top: ${props.padding}%;
                      right: ${props.padding}%;
                      bottom: ${props.padding}%;
                      left: ${props.padding}%;
                  `
                : css`
                      top: 0;
                      right: 0;
                      bottom: 0;
                      left: 0;
                  `}
    }
`;

export default StyledLogo;
